import React from 'react';
import { useClientForm } from '../../../../hooks/useClientForm';
import ClientFormView from './ClientFormView';
import NavigationButtons from '../../shared/NavigationButtons';
import { useFormContext } from 'react-hook-form';

/**
 * Componente container para o formulário de dados do cliente
 * 
 * @param {Object} props - Propriedades do componente
 * @param {string} props.salonId - ID do salão
 * @param {Object} props.salonConfig - Configurações do salão
 * @param {Function} props.onBack - Função chamada ao voltar
 * @param {Function} props.onSubmit - Função chamada ao submeter o formulário
 * @param {boolean} props.isAdmin - Indica se está no modo admin
 */
const ClientForm = ({
  salonId,
  salonConfig = {},
  onBack,
  onSubmit,
  isAdmin = false
}) => {
  // Usar o hook personalizado para gerenciar o formulário do cliente
  const {
    register,
    errors,
    isSubmitting,
    bookingData,
    submitBooking
  } = useClientForm({ 
    salonId, 
    onSubmitSuccess: () => {} // A função de sucesso é gerenciada pelo componente pai
  });
  
  // Obter setValue do React Hook Form
  const { setValue } = useFormContext();
  
  // Handler de submissão do formulário
  const handleFormSubmit = async () => {
    await submitBooking(onSubmit);
  };
  
  return (
    <ClientFormView
      selectedServices={bookingData.services}
      selectedDate={bookingData.date}
      selectedTime={bookingData.time}
      selectedProfessional={bookingData.professional}
      errors={errors}
      register={register}
      handleSubmit={handleFormSubmit}
      onBack={onBack}
      isLoading={isSubmitting}
      primaryColor={salonConfig?.primaryColor}
      NavigationButtons={NavigationButtons}
      isAdmin={isAdmin}
      salonId={salonId}
      setValue={setValue}
      salonConfig={salonConfig}
    />
  );
};

export default ClientForm; 